import { Col, Row } from "react-bootstrap"
import { Card } from "antd"
import moment from "moment/moment"
import Image from "next/image"
import * as ImageConstants from "../../../constants/images"
import NewsStaticCarouselRPP from "@components/News/NewsStaticCarouselRPP"
import { PredictionNewsContent } from "@components/Predictions/PredictionNewsContent"
import React from "react"
import { SimplifiedSingleNews } from "../../../types/news"
import { MatchBettingStats } from "@components/Match/MatchBettingStats"
import { TeamBettingStatsWithParameterFlat } from "../../../types/teamBettingStats"
import { GroupStandings } from "@components/Competition/GroupStandings"
import { TeamBettingParameterStandingFlat } from "../../../types/groupTeamStanding"
import { NewsContent } from "@components/News/NewsContent"
import Link from "next/link"

export default function News({
  news,
  homeTeamBettingStats,
  awayTeamBettingStats,
  teamStandings,
  trigger,
}: {
  news: SimplifiedSingleNews
  // relatedNews: LocalizedNews[]
  // playerStandings: LocalizedCompetitionSeasonPlayerStanding[]
  // bookmakerBonuses: SimplifiedBookmakerBonus[]
  homeTeamBettingStats?: TeamBettingStatsWithParameterFlat
  awayTeamBettingStats?: TeamBettingStatsWithParameterFlat
  teamStandings: TeamBettingParameterStandingFlat[]
  trigger?: string | null
}) {
  const hasImage = !!news.image?.path

  return news.type !== "predictions" ? (
    <Row className={"marginZero"}>
      <Col>
        <Card className={"hs-border-div marginTopBottomFive news-card"}>
          {<h1 style={{ textTransform: "uppercase", marginBottom: "5px" }}>{news.title}</h1>}
          {news.subtitle && <h4 style={{ marginBottom: "5px", color: "#707070" }}>{news.subtitle}</h4>}
          <div>
            <Col xl={6} lg={6} md={6} xs={12}>
              {news.authors && news.authors[0] && (
                <Link href={`/autori/${news.authors[0].author?.calciocomSlug}`} passHref>
                  <a key={news.authors[0].id}>
                    Autore <span style={{ color: "#f4c400" }}>{news.authors[0].author?.name}</span>
                  </a>
                </Link>
              )}
            </Col>
            {news.publishedAt && (
              <span className={"dateNews-span"}>
                Pubblicata il <span className={"dateNews"}>{moment(news.publishedAt).format("DD/MM/YYYY")}</span>
              </span>
            )}
          </div>
          {news.type !== "predictions" && (
            <div style={{ paddingTop: "5px", paddingBottom: "5px", textAlign: "center" }} className={"news-image"}>
              <Image
                src={
                  hasImage
                    ? news.image?.path || ImageConstants.NEWS_MISSING_IMAGE_PATH
                    : ImageConstants.NEWS_MISSING_IMAGE_PATH
                }
                className={"hs-border-image"}
                alt={news.title}
                layout={"intrinsic"}
                width={800}
                height={530}
              />
              {hasImage && (
                <div className={"newsImageCopyright"}>{`${
                  news.imageDescription ? news.imageDescription : "©Shutterstock/No use without permission"
                }`}</div>
              )}
            </div>
          )}
          <NewsContent news={news} trigger={trigger} />
          {news?.id === 245 && <NewsStaticCarouselRPP />}
        </Card>
      </Col>
      {/*<Col>*/}
      {/*  <NewsRelatedNews news={relatedNews} />*/}
      {/*</Col>*/}
      {/*<Col md={4}>*/}
      {/*  <NewsRelatedTopics competitions={news.competitions} teams={news.teams} players={news.players} />*/}
      {/*  <CompetitionStatistics playerStandings={playerStandings} />*/}
      {/*</Col>*/}
    </Row>
  ) : (
    <Row className="paddingZero">
      <PredictionNewsContent news={news} trigger={trigger} />
      {homeTeamBettingStats && awayTeamBettingStats && news.predictionMatch && (
        <Row className={"page-desktop-row"}>
          <Col lg={12} xs={12} className={"page-mobile-col"}>
            <MatchBettingStats
              match={news.predictionMatch}
              homeTeamBettingStats={homeTeamBettingStats}
              awayTeamBettingStats={awayTeamBettingStats}
              isH1={false}
            />
          </Col>
        </Row>
      )}
      {news.predictionMatch && teamStandings.length > 0 && (
        <Row className={"page-desktop-row"}>
          <Col lg={12} xs={12} className={"page-mobile-col"}>
            <GroupStandings
              competitionCalciocomSlug={news.predictionMatch.competition?.calciocomSlug || null}
              seasonCalciocomSlug={news.predictionMatch.season?.calciocomSlug || null}
              teamStandings={teamStandings}
              homeTeamId={news.predictionMatch.homeTeam?.id}
              awayTeamId={news.predictionMatch.awayTeam?.id}
              headerTitle={`Pronostici e Scommesse | ${news.predictionMatch.homeTeam?.name} - ${news.predictionMatch.awayTeam?.name}`}
              isH1={false}
            />
          </Col>
        </Row>
      )}
    </Row>
  )
}
